import React, { Component, ReactNode } from 'react';
import OpenDesignStateEnum from '@inter-ikea-kompis/component-open-design-code/lib/enums/OpenDesignCodeStateEnum';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import SkapaButton from '@ingka/button';
import SkapaText from '@ingka/text';
import { Platform, SofaRangeName, DeviceType, WriteDirection } from 'sofa-reborn-react';
import { localeService } from '../../services';
import SkapaModal, {
	Sheets as SkapaSheets,
	ModalHeader as SkapaModalHeader,
	ModalBody as SkapaModalBody,
} from '@ingka/modal';
import {
	KompisOpenDesignCode,
	KompisPopover,
	KompisPopoverPadding,
	KompisPopoverPosition,
} from '@inter-ikea-kompis/react-components';
import PopoverDirectionEnum from '@inter-ikea-kompis/component-popover/lib/enums/PopoverDirectionEnum';

import styled from 'styled-components';
import { IDexfSettings, ITranslations } from '@inter-ikea-kompis/types';

type Props = {
	platform: Platform;
	deviceType: DeviceType;
	writeDirection: WriteDirection;
	showOpenDesign: boolean;
	kompisSettings?: IDexfSettings | null;
	kompisTranslations?: ITranslations | null;
	sofaRangeName: SofaRangeName;
	openDesignState: OpenDesignStateEnum;
	onOpenVpcCode: (vpcCode: string) => void;
	onOpenDesignClick: () => void;
	onClose: () => void;
};

export const OpenDesignWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const OpenDesignCodeWrapper = styled.div`
	width: 450px;
`;

export const UserInfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

/**
 * React component.
 *
 */
export default class OpenDesign extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */

	public render(): ReactNode {
		const { props } = this;
		const { onOpenDesignClick, onOpenVpcCode, onClose } = props;

		if (!props.kompisSettings || !props.kompisTranslations) {
			return null;
		}
		if (props.platform === 'kiosk') {
			return (
				<KompisPopoverPosition>
					<SkapaButton
						text={localeService.getTranslation('openSavedDesign')}
						type={'secondary'}
						small={true}
						onClick={(): void => onOpenDesignClick()}
						style={{ margin: props.writeDirection === 'ltr' ? '0 8px 0 0' : '0 0 0 8px' }}
					/>
					<KompisPopover
						visible={props.showOpenDesign}
						theme={SkapaTheme}
						direction={PopoverDirectionEnum.bottom}
						zIndex={5}
					>
						<KompisPopoverPadding theme={SkapaTheme}>
							<OpenDesignCodeWrapper>
								<KompisOpenDesignCode
									theme={SkapaTheme}
									translations={props.kompisTranslations.kompis}
									state={props.openDesignState}
									onOpen={(e: CustomEvent): void =>
										onOpenVpcCode && onOpenVpcCode(e.detail.vpcCode)
									}
								/>
							</OpenDesignCodeWrapper>
						</KompisPopoverPadding>
					</KompisPopover>
				</KompisPopoverPosition>
			);
		}
		return (
			<>
				<SkapaButton
					text={localeService.getTranslation('openSavedDesign')}
					type={'secondary'}
					small={true}
					onClick={(): void => onOpenDesignClick()}
					style={{ margin: props.writeDirection === 'ltr' ? '0 8px 0 0' : '0 0 0 8px' }}
				/>
				<SkapaModal
					visible={props.showOpenDesign}
					handleCloseBtn={(): void => onClose && onClose()}
				>
					<SkapaSheets
						size={'small'}
						alignment={'right'}
						header={
							<SkapaModalHeader
								title={localeService.getTranslation('loginOpenDesignDialogueTitle')}
							/>
						}
						footer={null}
						style={{
							zIndex: 10,
							borderTop:
								SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
							borderBottom:
								SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
						}}
					>
						<SkapaModalBody>
							<SkapaText tagName={'h2'} headingSize={'m'}>
								{localeService.getTranslation('loginOpenCodeDialogueHeader')}
							</SkapaText>
							<KompisOpenDesignCode
								theme={SkapaTheme}
								translations={props.kompisTranslations.kompis}
								state={props.openDesignState}
								onOpen={(e: CustomEvent): void => onOpenVpcCode && onOpenVpcCode(e.detail.vpcCode)}
							/>
						</SkapaModalBody>
					</SkapaSheets>
				</SkapaModal>
			</>
		);
	}
}
